<template>
    <template-kaban
        :page-title="pageTitle"
        :is-display-contact-details="isDisplayContactDetails"
        :is-permission-to-view-contact-details="isPermissionToViewContactDetails"
        :is-multi-select-mode="isMultiSelectMode"
        :has-permission-to-change-owner-in-bulk="hasPermissionToChangeOwnerInBulk"
        @update:isDisplayContactDetails="toggleDisplayContactDetails"
        @update:isMultiSelectMode="val => isMultiSelectMode = val"
        @filter="filter"
        @search="search"
        @delete="deleteItem"
    >
        <template v-if="checkedItens.length && (hasPermissionToChangeStageInBulk || hasPermissionToChangeOwnerInBulk)" #bulk>
            <div class="bulk-container">
                <div  class="number-card">
                    <span class="bulk-text">Você selecionou <strong class="bulk-text-number">{{ checkedItens.length }}</strong> {{ checkedItens.length > 1 ? 'cards' : 'card' }}</span>
                </div>
                <div class="actions-bulk">
                    <div class="select-container">
                        <ui-select-v2
                            v-model="valueSelect"
                            :data="availableMassActions"
                            return-value="valueSelect"
                            :placeholder="'Selecione uma ação'"
                            :search="false"
                            :show-footer="false"
                            size="sm"
                            :margin-botton="false"
                            @input="openBulkModal"
                        />
                    </div>
                    <span 
                        class="clear-action"
                        @click="clearSelectedCards"
                    >
                        Limpar seleção
                    </span>
                </div>
                <div class="key-text">
                    <span class="bulk-text">Use ESC para sair</span>
                </div>
            </div>
        </template>
        <template #body>
            <div class="kanban-area scroll-color">
                <section v-for="column in columns" :key="column.id">
                    <ui-kanban-column
                        :index="column.id"
                        :title="column.title"
                        :number="column.totalCount"
                        :loading="column.loading"
                        :has-link="column.hasLink"
                        :link-action="toSecondFunnel"
                        :link-payload="column.id"
                        :status="column.status"
                        :idles="column.idleRules"
                        :is-status="!!id"
                        :type-negotiation="column.winProbability"
                        :total-negotiation="column?.costTotal?.toString() ?? '0'"
                        :funnel-id="funnel_id"
                        @next="scrollHandler"
                        @filter="filterHandler"
                        @clear="clearHandler"
                    >
                        <template #body>
                            <draggable
                                v-model="column.cards"
                                v-bind="dragOptions"
                                :disabled="isMultiSelectMode"
                                group="column"
                                class="drag-area"
                                draggable=".drag-card"
                                @change="dragHandler($event, column.id)"
                            >
                                <section
                                    v-for="card in column.cards"
                                    :key="card.id"
                                    class="drag-card"
                                    :data-find-id="column.id"
                                >   
                                    <ui-kanban-card-deals
                                        :id="card.id"
                                        :card="card"
                                        :status="card.status"
                                        :customer-name="card.customer_name"
                                        :customer-mobile="card?.customer_mobile"
                                        :customer-country-code-mobile="card?.customer_country_code_mobile"
                                        :customer-phone="card?.customer_phone"
                                        :customer-country-code-phone="card?.customer_country_code_phone"
                                        :customer-email="card.customer_email"
                                        :customer-cpf="card.customer_cpf"
                                        :owner-image="card.owner_image"
                                        :owner-name="card.owner_name"
                                        :product-name="card.product_name"
                                        :idles="card.idles"
                                        :message-update="card.message_update"
                                        :update="card.update"
                                        :modify="card.modify"
                                        :idle-color="card.idle_color"
                                        :reserve="card.reserve"
                                        :proposal-value="card.proposal_value"
                                        :cost="card?.cost?.toString() ?? '0'"
                                        :menu-card="card.buttons"
                                        :status-id="id"
                                        :is-permission-to-duplicate-deal="isPermissionToDuplicateDeal"
                                        :is-display-contact-details="isDisplayContactDetails" 
                                        :multi-select="isMultiSelectMode"
                                        @select="onCardSelect"
                                        @deselect="onCardDeselect"
                                    />
                                </section>

                                <div
                                    v-show="column.loading && column.cards.length > 0"
                                    class="loading-area"
                                >
                                    <ui-load-indicator
                                        bg-color="#e7e9f4"
                                        color="#69D296"
                                        :h="50"
                                        :stroke="8"
                                    />
                                </div>
                            </draggable>
                        </template>
                    </ui-kanban-column>
                </section>
            </div>
            <change-stage-status-modal-bulk
                name="change-stage-status-modal-bulk"
                :deals="checkedItens"
                @bulk-step-data="onBulkStepDataReceived"
            />
            <bulk-change-stage-step
                name="bulk-step-modal"
                :deals="checkedItens"
                :stage="bulkStage"
                :status="bulkStatus"
                @close-bulk-step="onBulkStepClosed"
            />
            <change-responsible-modal-bulk
                name="change-responsible-modal-bulk"
                :deals="checkedItens"
                @bulk-step-data="onBulkResponsibleStepDataReceived"
            />
            <bulk-change-responsible-step
                name="bulk-responsible-step-modal"
                :deals="checkedItens"
                :responsible="bulkResponsible"
                @close-bulk-step="onBulkStepClosed"
            />
        </template>
    </template-kaban>
</template>
<script>
	import TemplateKaban from './template/index.vue'
	import { uiKanbanColumn, uiKanbanCardDeals } from '@/components/ui/kanban'
	import { uiLoadIndicator } from '@/components/ui'
	import { defaultMenuCard, defaultParams } from './data'
	import { loaderMixin, alertMixin, helpersMixin, utilMixin } from '@/mixins'
	import { funnel, idle, reserve, funnels, groups } from '@/services/axios'
	import Deal from '@/services/axios/modules/deal'
	import { idleHooks } from '@/services/hooks'
	import draggable from 'vuedraggable'
    import changeStageStatusModalBulk from '@/components/ui-facilita/change-stage-status-modal-bulk'
    import changeResponsibleModalBulk from '@/components/ui-facilita/change-responsible-modal-bulk'
    import BulkChangeStageStep from '@/components/ui-facilita/change-stage-status-modal-bulk/bulk-change-stage-step'
    import BulkChangeResponsibleStep from '@/components/ui-facilita/change-responsible-modal-bulk/bulk-responsible-step'

	import { mapGetters } from 'vuex'
	import { storage } from '@/services/storage'
	import { defaultGtm } from './default'
    import {  uiSelectV2  } from '@/components/ui/form'

	const moment = require('moment')
	require('moment/locale/pt-br')

	const defaultDrag = () => ({
		card: false,
	})

	export default {
		name: 'ui-deals-funnel',
		components: {
			uiKanbanColumn,
			uiLoadIndicator,
			uiKanbanCardDeals,
			TemplateKaban,
			draggable,
            changeStageStatusModalBulk,
            BulkChangeStageStep,
            uiSelectV2,
            changeResponsibleModalBulk,
            BulkChangeResponsibleStep
		},

		mixins: [
			loaderMixin,
			alertMixin,
			helpersMixin,
			utilMixin
		],

		props: {
			id: {
				type: [String, Number],
				default: null
			},
			title: {
				type: String,
				default: null
			},
		},

		data() {
			return {
				columns: [],
				replick: {},
				oldStage: null,
				drag: { ...defaultDrag() },
				filters: [],
				menuAllowed: storage.get('allowed_menu'),
				searchText: '',
				setElement: null,
				throwNewError: null,
				gtm: { ...defaultGtm() },
				actiosStatus: null,
                isPermissionToChangeState: false,
                isPermissionToDuplicateDeal: false,
				pageTitle:'',
				stages:[],
				funnel_id:'',
                isPermissionToViewContactDetails: false,
                isDisplayContactDetails: false,
                isMultiSelectMode: false,
                valueSelect: null,
                checkedItens: [],
                selectMassAction: [],
                bulkStage: { id: null, name: '' },
                bulkStatus: { id: null, name: '' },
                bulkResponsible: { id: null, name: '' },
                hasGroupPermissionToChangeOwner: false,
			}
		},

		computed: {
			...mapGetters('auth', {
				user: 'getUser',
			}),

			getTransferReservesActive() {
				return JSON.parse(storage.get('transfer-reserves'))
			},

			dragOptions() {
				return {
					animation: 200,
					group: 'description',
					disabled: false,
					ghostClass: 'ghost-card',
					search: '',
				}
			},

			dealsCountComputed() {
				let count = 0

				this.columns.forEach((e) => {
					count += e.cards.length
				})

				return count
			},

            hasPermissionToChangeStageInBulk() {
                const user = JSON.parse(localStorage.getItem('fac_user_logged') || '{}')

                return (
                    user?.config_permissions?.userPrivilegedMoveDeal === 1 &&
                    user?.config_permissions?.bulkActionMoveDeal === 1
                )
            },

            hasPermissionToChangeOwnerInBulk() {
                const user = JSON.parse(localStorage.getItem('fac_user_logged') || '{}')

                const perms = user?.config_permissions ?? {}
                return perms.bulkActionChangeDealOwner === 1 && this.hasGroupPermissionToChangeOwner
            },

            availableMassActions() {
                const actions = []
                if (this.hasPermissionToChangeStageInBulk) {
                  actions.push({
                    label: 'Alterar Etapa e Status',
                    valueSelect: 'alterar-etapa-status'
                  })
                }

                if (this.hasPermissionToChangeOwnerInBulk) {
                  actions.push({
                    label: 'Alteração de Responsável',
                    valueSelect: 'alteração-de-responsável'
                  })
                }
            
                return actions
            }

		},

        watch: {
            hasPermissionToChangeOwnerInBulk(newVal) {
                if (newVal) {
                    this.selectMassAction.push({
                        label: 'Alteração de Responsável',
                        valueSelect: 'alteração-de-responsável'
                    })
                }
            }
        },

		async mounted() {
            window.addEventListener('keydown', this.handleMultiSelectShortcut)

            this.$root.$on('toggle-multi-select', (val) => {
                this.isMultiSelectMode = val
            })

            this.$root.$on('clear-selected-deals', this.clearSelectedCards)

            const userId = this.user?.id
            const localStorageKey = `show-display-contact-kanban-${userId}` 
            const storedValue = storage.get(localStorageKey)

            if (storedValue !== null) {

                this.isDisplayContactDetails = (storedValue === 'true')
            }
           
            await this.getPermissions()

            
            if (this.hasPermissionToChangeStageInBulk) {
                this.selectMassAction.push({
                    label: 'Alterar Etapa e Status',
                    valueSelect: 'alterar-etapa-status',
                })
            }

            if (this.hasPermissionToChangeOwnerInBulk) {
                this.selectMassAction.push({
                    label: 'Alteração de Responsável',
                    valueSelect: 'alteração-de-responsável',
                })
            }

            this.$root.$on('modal-result-funnel-move-to', (data) => {
				try {
					if(this.id)
						return this.actionsCard(data.column, data.funnel_stage_id, data.data, data.funnel_stage_status_id)
					return this.actionsCard(data.column, data.funnel_stage_id, {...data.element}, data.funnel_stage_status_id)
				} catch (error) {
					this.$mx_alertError(error)
				}
			})
			this.$root.$on('cancel-move-funnel-move-to', () => {
				this.moveCardTo(...this.replick.data)
			})
			this.$root.$on('modal-success-choose-unit-reserve', (data) => {
				const column = this.findColumnIndex(data.column)
				this.moveCard(
					data.id,
					column,
					data.funnel_stage_id,
					data.funnel_stage_status_id,
					data.reserve_id
				)
			})

			// Evento responsavel por mover o item ao alterar etapa e status pelo modal
			this.$root.$on('modal-result-funnel-move-to-status', async (data) => {
				this.replick = {
					element: data.event,
					data: [
						data.new.funnel_stage_id,
						data.old.funnel_stage_id,
						data.old.funnel_stage_status_id,
						data.new.id
					]
				}
				const type = this.id ? 'funnel_stage_status_id' : 'funnel_stage_id'

				await this.moveCardTo(
					data.old[type],
					data.new.funnel_stage_id,
					data.new.funnel_stage_status_id,
					data.new.id
				)

				if(this.id){
					this.oldStage = this.findColumnIndex(data.old.funnel_stage_status_id)
					let index = this.findColumnIndex(data.new.funnel_stage_status_id)
					this.actionsCard(index, data.new.funnel_stage_status_id, data.event)
				} else {
					this.oldStage =this.findColumnIndex(data.old.funnel_stage_id)
					let index = this.findColumnIndex(data.new.funnel_stage_id)
					this.actionsCard(index, data.new.funnel_stage_id, data.event, data.new.funnel_stage_status_id)
				}

			})

			this.$root.$on('modal-result-create-deal-modal', (data) => {
				const column = this.findColumnIndex(data.funnel_stage_id)
				let color = '#868fa0'
				var dateIdle = '-'
				if(data.moved_at) {
					color = idleHooks.handleColor(
						data.moved_at,
						data.funnel_stage_id,
						data.funnel_stage_status_id,
						this.columns[column].idleRules
					)
					dateIdle = `${this.getIdleTime(data.moved_at)}`
				}
				const colorCard =  color
				const date = dateIdle
				const update = `${this.getIdleTime(data.updated_at)}`
				const messageUpdate = `${this.messageUpdate(data.updated_at)}`

				const procedureButtons = this.makeMenuCards([])

				const ownerName = 'Aguardando processamento.'
                
                this.columns[column].cards.unshift({
					...data,
					customer_name: data.customer.name,
					customer_cpf: data.customer?.cpf,
					customer_email: data.customer?.email,
					customer_id: data.customer_id,
					customer_mobile: data.customer.mobile,
					customer_phone: data.customer.phone,
					product_id: data.product && data.product.id ? data.product.id : null,
					product_name: data.product && data.product.name ? data.product.name : null,
					idle_color: colorCard,
					id: data.id,
					allow_fill: data.allow_fill,
					status: data.status || data.stage && data.stage.name ? data.stage.name : '',
					owner_image: this.getImgCDN(''),
					owner_name: ownerName,
					idles: date,
					update: update,
					message_update: messageUpdate,
					reserves: null,
					buttons: procedureButtons
				})

				this.columns[column].totalCount = this.columns[column].cards.length

			})
		},

		beforeDestroy() {
            window.removeEventListener('keydown', this.handleMultiSelectShortcut)
            this.$root.$off('toggle-multi-select')
			this.$root.$off('modal-result-funnel-move-to')
			this.$root.$off('modal-success-choose-unit-reserve')
			this.$root.$off('modal-result-funnel-move-to-status')
			this.$root.$off('modal-result-create-deal-modal')
			this.$root.$off('cancel-move-funnel-move-to')
            this.$root.$off('clear-selected-deals', this.clearSelectedCards)
		},

		methods: {
			/**
			 * @param {Object} column
			 */
			async dragHandler(event, column) {
				// Chama a função para mover o card
				if(event.added) this.setElement = {...event.added.element}
				else return
				const index = this.findColumnIndex(column)

				var action

				// Verifica a quantidade de status da etapa
				this.replick =
					{
						element: {...this.setElement},
						data: [column, this.setElement.funnel_stage_id, this.setElement.funnel_stage_status_id, this.setElement.id]
					}

				this.oldStage = this.findColumnIndex(this.setElement.funnel_stage_id) == -1
								? this.findColumnIndex(this.setElement.funnel_stage_status_id)
								: this.findColumnIndex(this.setElement.funnel_stage_id)


				if (this.columns[index].hasLink) {
					if(this.columns[index].actions && this.columns[index].actions.length > 0) {
						action = this.columns[index].actions.filter(res => {
							return res.action == 'make_reserve'
						})
					}
					return this.$root.$emit('modal-open-funnel-move-to', {
						name: this.columns[index].title,
						status: this.columns[index].status,
						stage: column,
						id: this.setElement.id,
						element: this.setElement,
						column: index,
						replick: [column, this.setElement.funnel_stage_id, this.setElement.funnel_stage_status_id, this.setElement.id],
						load: !action || action.length == 0
					})
				}
				else {
					 this.actionsCard(index, column, this.setElement)
				}
			},
			async actionsCard (index, column, element, status) {
				if (this.columns[index].actions && this.columns[index].actions.length && this.columns[index].actions.length > 0) {
					let setActionsCard = this.columns[index].actions.filter( val => {
						return val.action === 'make_sale'
					})

					const makeSale = status && setActionsCard.length > 0 && status == setActionsCard[0].funnel_stage_status_id ||
									 !status && setActionsCard.length > 0 && column == setActionsCard[0].funnel_stage_id 	   ||
									 this.id && setActionsCard.length > 0 && column == setActionsCard[0].funnel_stage_status_id
					if (makeSale) {
						// Trata se o deal tem mais de uma reserva.
						const card = this.findCardIndex(index, element.id)
						const columnSet = this.columns[index]
						this.procedureReturn(columnSet, card)

						if (element.reserves && element.reserves > 1) {

							return this.$root.$emit('modal-open-choose-unit-reserve', {
								id: this.id ? this.id : element.id,
								column,
								funnel_stage_id: this.id ? this.id : column,
								funnel_stage_status_id: this.id ? column : status
							})
						}else {
							const { data } = await reserve.getAllV2('', {
								where: `status:reserved,deal_id:${element.id}`,
							})
							const dealReserve = data.data
							let reserveId = dealReserve.length === 1 ? dealReserve[0].id : null
							return this.moveCard(
									element.id,
									index,
									this.id && !status ? this.id : column,
									this.id && !status ? column : status,
									reserveId
									)
						}
					}
				}
				return this.moveCard(
 					element.id,
 					index,
					this.id && !status ? this.id : column,
					this.id && !status ? column : status
 				)
			},
			/**
			 * @param {Number} id
			 * @param {Number} index
			 * @param {Number} stage
			 * @param {Number} status
			 * @param {Number} reserve_id
			*/
			async moveCard(id, index, stage, status = null, reserve_id = null) {
				try {
					// Valida se o registro conta com procedimentos
					// caso tenha não será possível mover o card
					const card = this.findCardIndex(index, id)
					const column = this.columns[index]
					this.throwNewError = null
					this.procedureReturn(column, card)

					if(this.throwNewError) throw new Error(this.throwNewError)
					let body = {
						funnel_stage_id: stage,
					}

					if (status) body['funnel_stage_status_id'] = status
					if (reserve_id) body['reserve_id'] = reserve_id

					const { data } = await funnel.updateV2('deal/', `${id}/move`, body)
					if (data.code === 0) {
						// Trata qual modal será aberto, caso precise.
						this.$root.$emit('close-modal-animation', false)
						throw new Error(data?.message || data.msg)
					}

					if (data.msg && data.status !== 'success') {
						this.moveCardTo(...this.replick.data)
						return this.$root.$emit('close-modal-animation', false, data.msg)
					} else {
						var idleColor = this.setIdles(column)
						column.cards[card].idle_color = idleColor && idleColor.color ? idleColor.color : '#868fa0'
						this.$root.$emit('close-modal-animation', true, 'Atualizado com successo!')
					}

					// Valida se é necessário abrir algum modal pós movimentação
					if (column.actions && column.actions.length > 0) {
						column.actions.forEach((action) => {
							// Valida se as regras sao da etapa e status corretas
							if (action.funnel_stage_id !== stage) return

							// Trata qual modal será aberto
							if (action.action === 'make_reserve') {
								if (
									!this.replick.element.reserves &&
									!this.replick.element.unity_id || this.replick.element.unity_id === ""
								) {
									this.$root.$emit('modal-open-global--request-reserve', this.replick.element)
								}else {
									return this.resetCardInfo(index, id, stage, status)
								}
							}
						})
					}

					/**
					 * Atualiza o valor total do card
					 */
					this.columns[index].costTotal = this.columns[index].costTotal + column.cards[card].cost
					this.columns[this.oldStage].costTotal = this.columns[this.oldStage].costTotal - column.cards[card].cost


					/**
					 * Atualiza o contador do card
					 */
					if(this.columns[index].cards.length > 0) this.columns[index].totalCount = this.columns[index].totalCount + 1
					if(this.columns[index].cards.length == 0) this.columns[index].totalCount = this.columns[index].totalCount = 0

					if(this.columns[this.oldStage].cards.length > 0) this.columns[this.oldStage].totalCount = this.columns[this.oldStage].totalCount - 1
					if(this.columns[this.oldStage].cards.length == 0) this.columns[this.oldStage].totalCount = 0

					this.resetCardInfo(index, id, stage, status)
					this.replick = {}
				} catch (error) {
					this.$root.$emit('close-modal-animation', false)
					this.$mx_alertError(error?.data?.msg || error)
					this.moveCardTo(...this.replick.data)
					this.replick = {}
				}
			},
			procedureReturn (column, card, replick) {
                // Se o usuário tem permissão para mudar o estado, ignorar validações
                if (this.isPermissionToChangeState) return

				if (column.winProbability && column.winProbability == 'lost') return false
				if(column.cards &&
					column.cards[card].buttons &&
					column.cards[card].buttons.length > 0 &&
					column.cards[card].buttons[1].itens &&
					column.cards[card].buttons[1].itens.length > 0) {
						this.$root.$emit('close-modal-animation', false)
						if(replick) this.moveCardTo(...replick)
						this.throwNewError = 'Não é possível mover o card, pois ele conta com procedimentos.'
				}
			},

			setIdles(column) {
				var filterIdle
				if(column.idleRules) {
					filterIdle = column.idleRules.filter(res => {
						return res.time_start == 0
					})
				}
				return filterIdle && filterIdle.length > 0 ? filterIdle[0] : null
			},
			/**
			 * ! Precisa de melhorias na nomenclatura
			 * @param {Number} column
			 * @param {Number} id
			 */
			removeCard(column, id) {
				setTimeout(() => {
					const j = this.findCardIndex(column, id)
					if (j !== -1) this.columns[column].cards.splice(j, 1)
				}, 1000)
			},

			/**
			 * @param {Number} id
			 * @param {Number} title
			 */
			toSecondFunnel(funnel_id,id, title) {
				this.$gtm.trackEvent(this.gtm.statusFilter)
				const route = this.$router.resolve({
					name: 'sales.deals.funnel.status',
					params: {
						funnel_id,
						id,
						title
					},
				})

				window.open(route.href, '_blank')
			},

			/**
			 * Filtra as regras de ociosidades de acordo com o ID da etapa e status
			 */
			filterColumnIdles(idles, statusId) {
				return this.id
					? idles.filter(idle => !idle.funnel_stage_status_id || idle.funnel_stage_status_id === statusId)
					: idles
			},

			/**
			 * Busca os stages do quadro
			 */
		async getFunnelStages() {
			this.funnel_id = this.$route.params?.funnel_id;
			let stage_id = this.$route.params?.id;
			let funnelItems = [];
			funnels.getFunnel(this.funnel_id).then(async (response) =>{

				funnelItems = response?.data?.data?.stages ;

				this.pageTitle = response.data?.data?.name ;

				if (response.data.status != 'success') throw new Error('Não foi possível carregar os estágios.')

				let stageIdles = [];

                if(this.$route.name == "sales.deals.funnel.pre") this.pageTitle = "Funil de Pré-Atendimento" ;
                if(this.$route?.params?.title) {this.pageTitle = `Funil - ${this.$route?.params?.title}`};
				if (stage_id) {
					let url = `/stage/${stage_id}/status`;
					const { data } = await idle.getByStage(stage_id)
					stageIdles = [...data.data];
					let stagesResponse  =  await funnel.getAllV2(url, '')
					funnelItems = stagesResponse.data.data
				}
				if(!funnelItems?.length) throw new Error('Não existem etapas cadastradas nesse funil.')
				this.$store.dispatch('dataTable/setTotal', 0)
				this.columns = []
				const columns = funnelItems.map((item) => ({
					id: item.id,
					position: item.position,
					title: item.name,
					link: '',
					loading: false,
					cards: [],
					page: 1,
					lastPage: 1,
					hasLink: item.status && item.status.length > 0,
					idleRules: item.idles && item.idles.length
						? item.idles
						: this.filterColumnIdles(stageIdles, item.id),
					totalCount: 0,
					status: this.id ? item : item.status, // Caso column seja um status
					actions: item.action,
					filterParams: {
						status: [],
						idles: [],
						sort_by: { value: 'updated_at', dir: 'desc' }
					},
					winProbability: item.win_probability ? item.win_probability : null,
				}))

				this.columns = columns.sort((a, b) => (a.position > b.position ? 1 : -1))
				let requestList = []
				for (const key in this.columns) {
					const value = this.columns[key]
					this.columns[key].loading = true

					requestList.push(this.getDealsOnStage(
						this.id || value.id,
						this.id ? value.id : this.columns[key].filterParams.status,
						this.columns[key].filterParams.idles
					))
				}
				Promise.all(requestList).then(() => {
					this.$store.dispatch(
						'dataTable/setTotal',
						this.columns.map(item => item.totalCount).reduce((a, b) => a + b, 0)
					)
				})
			} ).catch((error) => {
				this.$mx_alertError( error?.data?.msg || error )
			})
		},

			/**
			 * Busca os deals do stage marcado
			 * ! Esta função pode ser divida em duas, uma para buscar os deals e outra pra validar as informações do mesmo.
			 *
			 * @param {Number} stageId
			 * @param {Number} statusId
			 * @param {Array} idleRules
			 */
			getDealsOnStage(stageId, statusId = null, idleRules = [], clear = false) {

                return new Promise((resolve, reject) => {
					const columnIndex = this.findColumnIndex(this.id ? statusId : stageId)

					if (columnIndex < 0) reject('Etapa não encontrada.')

					const column = this.columns[columnIndex]

					let index = this.filters.findIndex((e) => e.name === 'funnel_stage_status_id')
					if (index < 0) reject('Status não encontrado.')
					if(clear) this.filters[index].value = ''
					else {
						this.filters[index].value = this.$mx_hasValue(statusId)
							? statusId
							: this.filters[index].value
					}

					index = this.filters.findIndex((e) => e.name === 'idle_color_v2')
					if(this.filters[index].value == '') {
						if (index < 0) reject('Ociosidade não encontrada.')
						this.filters[index].value = idleRules
					}

					const params = {
						...defaultParams({
							sort_by: { ...column.filterParams.sort_by },
							search: this.searchText,
							page: column.page,
							filters: [
								...this.filters,
								{
									name: 'funnel_stage_id',
									value: stageId,
								}
							],
						}),
					}

					const deal = Deal.build()
					deal.dataTable(params)
						.then(response => {
							const data = response.data
							if (!data.data.length) resolve([])
							column.lastPage = Math.floor(data.recordsFiltered / params.perPage) + 1
							column.totalCount = data.recordsFiltered

							column.costTotal = data.costTotal

							const dealsList = data.data.map((item) => {

								const update = `${this.getIdleTime(item.updated_at)}`
								const messageUpdate = `${this.messageUpdate(item.updated_at)}`
								let color = '#868fa0'
								var dateIdle = '-'

								if (item.moved_at) {
									color = idleHooks.handleColor(item.moved_at,
									item.funnel_stage_id,
									item.funnel_stage_status_id,
									column.idleRules)

									dateIdle = `${this.getIdleTime(item.moved_at)}`
								}
								const colorCard = color
								const date = dateIdle

								const procedureButtons =
								this.makeMenuCards([
									...this.makeProcedureButtons((item.procedure_status_text ? item.procedure_status_text : item.procedure_stage_text), item.id),
								])

								let reserves = item.reserves

								if (reserves === undefined || reserves === 0) reserves = ''

								if (reserves && reserves > 1) {
									reserves = `${reserves} reservas`
								}

								if (reserves && reserves === 1) {
									reserves = `${reserves} reserva`
								}
								return {
									...item,
									id: item.id,
									allow_fill: item.allow_fill,
									status: item.status || item.stage,
									owner_image: this.getImgCDN(item.user_photo),
									owner_name:
										item.broker_name ||
										item.manager_name ||
										item.user_name ||
										'Sem responsável',
									idles: date,
									update: update,
									message_update: messageUpdate,
									reserve: reserves,
									idle_color: colorCard,
									buttons: procedureButtons,
								}
							})

							const dealsData = [...column.cards, ...dealsList]
							column.cards = dealsData
							column.loading = false

							resolve(true)
						})
				})
			},

			/**
			 * @param {Array} filters
			 * @param {String} name
			 * @param {Any} value
			 */
			changeFilterValue(filters, name, value) {
				const index = filters.findIndex((item) => item.name === name)
				filters[index].value = value
			},

			/**
			 * @param {Numner} id
			 */
			async scrollHandler(id) {
				const key = this.findColumnIndex(id)

                if (this.columns[key].loading) return

				if (this.columns[key].page >= this.columns[key].lastPage) return

				this.columns[key].loading = true
				this.columns[key].page++

				this.getDealsOnStage(
					this.id || id,
					this.id ? id : this.columns[key].filterParams.status,
					this.columns[key].filterParams.idles,
				)
			},

			/**
			 * Função handler que recebe os dados necessários e realiza uma filtragem dos dados
			 * de um status ou etapa
			 *
			 * @param {Object} params Parâmetros para filtragem
			 */
			async filterHandler(event) {
				const key = this.findColumnIndex(event.id)

				this.columns[key].loading = true
				this.columns[key].cards = []
				this.columns[key].totalCount = 0
				this.columns[key].page = 1
				this.columns[key].filterParams = { ...event.params }

				this.getDealsOnStage(
					this.id ? this.id : event.id,
					this.id ? event.id : this.columns[key].filterParams.status,
					this.columns[key].filterParams.idles,
				)
			},

			/**
			 * Função handler que recebe o ID de um status ou etapa e limpa os dados da
			 * última filtragem realizada
			 *
			 * @param {String|Integer} id ID do status ou etapa cujos filtros serão limpos
			 */
			async clearHandler(id) {
				const key = this.findColumnIndex(id)

				this.columns[key].loading = true
				this.columns[key].cards = []
				this.columns[key].totalCount = 0
				this.columns[key].filterParams = {
					status: [],
					idles: [],
					sort_by: { value: 'updated_at', dir: 'desc' }
				}

				this.getDealsOnStage(
					this.id || id,
					this.id ? id : this.columns[key].filterParams.status,
					this.columns[key].filterParams.idles,
					true
				)
			},

			/**
			 * @param {Numner} id
			 */
			findColumnIndex(id) {
				return this.columns.findIndex((column) => column.id === id)
			},

			/**
			 * @param {Numner} column
			 * @param {Numner} id
			 */
			findCardIndex(column, id) {
				if (this.columns[column] && this.columns[column].cards) {
					return this.columns[column].cards.findIndex((card) => card.id === id)
				} else {
					return -1
				}
			},

			/**
			 * @param {String} value
			 */
             async search(value) {
                this.$root.$emit('ui-search-box-loading-true');
                try {
                    this.searchText = value;
                    await this.getFunnelStages();
                } finally {

                    this.$root.$emit('ui-search-box-loading-false');
                }
            },


			/**
			 * @param {Date} time
			 */
			getIdleTime(time) {
				const date = moment.duration(moment().diff(time))
				const days = Math.floor(date.asDays())

				if (days > 1) return days + ' dias'
				if (days === 1) return days + ' dia'

				const hours = Math.floor(date.asHours())

				if (hours > 1) return hours + ' horas'
				if (hours === 1) return hours + ' hora'

				const minutes = Math.floor(date.asMinutes())

				if (minutes > 1) return minutes + ' min'

				return '1 min'
			},
			messageUpdate(time) {
				var data = moment(time).format('DD/MM/YY')
				var hour = moment(time).format('HH:mm')
				return  data + ' às ' + hour
			}, //messageUpdate


			/**
			 * @param {String} text
			 * @param {Number} id
			 */
			makeProcedureButtons(text, dealId) {
				if (!text) return []

				const data = text.split(',')

				return data.map((item) => {
					const [id, title] = item.split(':')
					return {
						id,
						title,
						action: 'modal-open-deal-multiple-precedure',
						gtm: {
							event: 'fac_button_click',
							category: 'vuejs-funil-vendas',
							action: 'click',
							label: title
						},
						payload: {
							id: id,
							dealId: dealId,
						},
					}
				})
			},

			/**
			 * @param {Array} data
			 */
			async filter(data) {
				this.filters = data
				await this.getFunnelStages()
			},

			/**
			 * @param {Object} procedures
			 */
			makeMenuCards(procedures) {
				const menuCard = [...defaultMenuCard(procedures, this.getTransferReservesActive?.active)]
				menuCard[0].itens = menuCard[0].itens.filter((item) => {
					if (
						!item.allowed_except.includes(this.user.user_group) &&
						(!item.menu_allowed || this.menuAllowed.includes(item.menu_allowed))
					) {
						return item
					}
				})

				return menuCard
			},

			/**
			 * @param {Number} oldColumn
			 * @param {Number} newStage
			 * @param {Number} newStatus
			 * @param {Number} dealm
			 */
			moveCardTo(oldColumn, newStage, newStatus, deal) {
				this.$root.$emit('modal-close-global--request-reserve')
				const oldColumnId = this.findColumnIndex(oldColumn)
				const newColumnId = this.findColumnIndex(this.id ? newStatus : newStage)

				const oldCardIndex = this.findCardIndex(oldColumnId, deal)
				const item = this.columns[oldColumnId].cards[oldCardIndex]

				this.columns[oldColumnId].cards.splice(oldCardIndex, 1)

				if (this.id && this.id != newStage) return

				this.columns[newColumnId].cards.unshift(item)
				this.resetCardInfo(newColumnId, item.id, newStage, newStatus)
			},

			/**
			 * @param {Number} columnId
			 * @param {Number} itemId
			 * @param {Number} stage
			 * @param {Number} status
			 */
			resetCardInfo(columnId, itemId, stage, status) {
				const column = this.columns[columnId]

				let title = column.title

				if (column.hasLink) {
					const statusID = column.status.findIndex((col) => col.id === status)
					title = column.status[statusID].name
				}

				// Reseta os dados do card
				const date = new Date()
				const dateFormated = date.toISOString()

				const id = this.findCardIndex(columnId, itemId)

				column.cards[id].updated_at = dateFormated
				column.cards[id].status = title
				column.cards[id].idles  = '1 min'
				column.cards[id].update  = '1 min'
				column.cards[id].funnel_stage_id = stage
				column.cards[id].funnel_stage_status_id = status
				column.cards[id].procedure_stage_text = ''
				column.cards[id].procedure_status_text = ''
				column.cards[id].stage_position = columnId
			},

            async getPermissions () {
                const userLogged = JSON.parse(storage.get("user_logged"))
                this.fetchUsersWithPermissions (userLogged)
                await this.fetchAllowGroupDuplicateDeal(userLogged)
            },

            fetchUsersWithPermissions (userLogged) {
                this.isPermissionToChangeState = !!userLogged?.config_permissions?.userPrivilegedMoveDeal
            },

            verifyIsPermissionToDeal(permissionData) {
                return !!permissionData?.data?.active
            },

            async fetchAllowGroupDuplicateDeal (userLogged) {
                try {
                    const { data: permissionData } = await funnel.getAllowGroupDuplicateDeal("")

                    this.isPermissionToDuplicateDeal = this.verifyIsPermissionToDeal(permissionData)

                    const userName = userLogged?.user_group
                    const { data: allGroups } = await groups.getGroups()

                    const matchedGroup = allGroups.find(group => group.name === userName)

                    if (matchedGroup && matchedGroup.permissions) {

                        // Permissão para duplicar
                        if (this.isPermissionToDuplicateDeal) {
                            this.isPermissionToDuplicateDeal =
                            Number(matchedGroup.permissions["funnel.deal.*.copie"]) === 1
                        }

                        //  validação para alteração de responsável em massa
                        const hasBulkOwnerChangePermission = matchedGroup.permissions["funnel.deal.*.change.owner"] === 1
                        this.hasGroupPermissionToChangeOwner = hasBulkOwnerChangePermission

                    } else {
                        this.isPermissionToDuplicateDeal = false
                    }

                    } catch (error) {
                        if (error.data && error.data.msg) {
                            this.$toastr.e(error.data.msg)
                        }
                    }
                },


			deleteItem(data) {
				this.removeCard(data.column, data.id)
			},
            toggleDisplayContactDetails(newValue) {
                const userId = this.user?.id
                const localStorageKey = `show-display-contact-kanban-${userId}`


                storage.set(localStorageKey, newValue ? 'true' : 'false')

                this.isDisplayContactDetails = newValue
            },

            toggleMultiSelectMode() {
                this.isMultiSelectMode = !this.isMultiSelectMode
            },
            handleMultiSelectShortcut(e) {
                const isAlt = e.altKey
                const isShift = e.shiftKey
                const isS = e.key.toLowerCase() === 's'
                const isEsc = e.key === 'Escape'
            
                if (isAlt && isShift && isS) {
                  e.preventDefault()

                  if (!this.hasPermissionToChangeStageInBulk) return
                  
                  this.toggleMultiSelectMode()
                }

                if (isEsc && this.isMultiSelectMode) {
                    this.isMultiSelectMode = false
                }

                if(!this.isMultiSelectMode) {
                    this.clearSelectedCards()
                }
            },

            onCardSelect(card) {

                if (!this.checkedItens.some(c => c.id === card.id)) {
                    this.checkedItens.push(card)
                }
            },
            onCardDeselect(card) {

                this.checkedItens = this.checkedItens.filter(c => c.id !== card.id)
            },

            clearSelectedCards() {
              this.checkedItens = []

              this.columns.forEach(column => {
                column.cards.forEach(card => {
                  card._selected = false 
                })
              })
          
              this.$root.$emit('clear-card-selection')
            },

            openBulkModal() {
                if (this.valueSelect === 'alterar-etapa-status') {
                   this.$root.$emit('modal-msg-open-change-stage-status-modal-bulk')

                   this.$nextTick(() => {
                     this.valueSelect = null
                   })
                 }

                 if (this.valueSelect === 'alteração-de-responsável') {
                this.$root.$emit('modal-msg-open-change-responsible-modal-bulk')
        
                this.$nextTick(() => {
                    this.valueSelect = null
                })
            }
            },
        // aqui inicia metodos da alteraçao em massa de responsáveis
            onBulkStepDataReceived({ stage, status }) {
                this.bulkStage = stage
                this.bulkStatus = status

                this.$root.$emit('modal-msg-open-bulk-step-modal')
            },

            onBulkStepClosed() {
                // Recarrega a listagem dos negócios
                this.getFunnelStages()
                this.clearSelectedCards()
                this.isMultiSelectMode = false
            },

            //aqui inicia alteração em massa de responsáveis
            onBulkResponsibleStepDataReceived({ responsible, changeResponsibleCustomer  }) {
                this.bulkResponsible = {
                    ...responsible,
                    changeResponsibleCustomer
                };

                this.$root.$emit('modal-msg-open-bulk-responsible-step-modal')

            },
            //aqui termina alteração em massa de responsáveis

		}
	}
</script>
<style lang="stylus" scoped>
	@import 'styles.styl'
</style>
